<script>
  import { dims } from '~/utils/dimensions.svelte';
</script>

<div style:height="{dims.bottom + dims.pad / 2}px"></div>
